import { Box, CircularProgress, styled, Typography } from "@mui/material";

// Responsive container: width 100%, keep a perfect circle
const DonutWrapper = styled(Box)(({ width }) => ({
  width,
  aspectRatio: "1 / 1",
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const InnerContent = styled(Box)({
  position: "absolute",
  textAlign: "center",
  color: "#fff",
  pointerEvents: "none",
});

// Responsive svg style (CircularProgress)
const ResponsiveProgress = styled(CircularProgress)({
  position: "absolute",
  width: "100% !important",
  height: "100% !important",
});

export default function OEEDonut({
  value = 70,
  target = 75,
  text = "",
  actualColor = "#FBC02D",
  targetColor = "#7D7D7D",
  emptyColor = "#FFFFFF",
  showText = true,
  showTarget = true,
  width = "100%",
  valueSize = "clamp(18px, 6vw, 42px)",
}) {
  const displayValue = value;

  const chartValue = Math.min(Number(value) || 0, 100);

  const yellowValue = chartValue;
  const greyValue = Math.max(target - chartValue, 0);

  return (
    <DonutWrapper width={width}>
      {/* white */}
      <ResponsiveProgress
        variant="determinate"
        value={100}
        thickness={5}
        sx={{ color: emptyColor }}
      />

      {/* grey */}
      <ResponsiveProgress
        variant="determinate"
        value={yellowValue + greyValue}
        thickness={5}
        sx={{
          color: targetColor,
          transform: "rotate(-90deg) !important",
        }}
      />

      {/* yellow */}
      <ResponsiveProgress
        variant="determinate"
        value={yellowValue}
        thickness={5}
        sx={{
          color: actualColor,
          transform: "rotate(-90deg) !important",
        }}
      />

      {/* Center text – responsive using clamp */}
      <InnerContent>
        {showText && (
          <>
            <Typography
              sx={{
                fontSize: "clamp(12px, 3vw, 20px)",
                fontWeight: 600,
              }}
            >
              {text}
            </Typography>
          </>
        )}
        <Typography
          sx={{
            fontSize: valueSize,
            fontWeight: 800,
            lineHeight: 0.8,
            color: actualColor,
          }}
        >
          {displayValue}%
        </Typography>

        {showTarget && (
          <Typography
            sx={{
              fontSize: "clamp(12px, 2.8vw, 18px)",
              opacity: 0.8,
            }}
          >
            {showText && "Target"} {target}%
          </Typography>
        )}
      </InnerContent>
    </DonutWrapper>
  );
}
